// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4595":"467ccb0de7302c38","5893":"85c62ff7dae6d538"}[chunkId] + ".css";
};